<style lang="sass" scoped>
.pay-sus
    text-align: center
    padding: 20px
    .ok-top
        font-size: 16px
        font-weight: 600
        img
            width: 185px
            margin: 10px auto
        span
            color: #FF3973
    .left-right
        width: 33.333%
        border: 1px solid #d4d4d4
        border-right: none
        background: #f5f5f5
        line-height: 30px
        padding: 0
        &.br
            border-right: 1px solid #d4d4d4
        span
            float: right
            border-left: 1px solid #d4d4d4
            background: #fff
            display: inline-block
            width: calc(100% - 120px)
            height: 30px
            text-align: left
            padding-left: 10px
            white-space: nowrap
            overflow: hidden
            text-overflow: ellipsis
    .qrs
        .qr
            display: inline-block
            margin: 30px
            font-size: 16px
            line-height: 30px
        img
            width: 160px
            height: 160px
            border: 1px solid #e9e9e9
    .qrs, .charge-info, .tips
        border: 1px solid #e9e9e9
    .charge-info
        margin: 10px 0
        padding: 20px
    .btn
        display: inline-block
        width: 160px
        height: 40px
        line-height: 40px
        font-size: 16px
        color: #FF3973
        border: 1px solid #FF3973
        border-radius: 4px
        margin: 20px 10px
        cursor: pointer
        &.cur
            border: none
            color: #fff
            background: linear-gradient(315deg,rgba(255,132,109,1) 0%,rgba(255,57,115,1) 100%)
    .tips
        padding: 20px
        line-height: 1
        font-size: 16px
        font-weight: 550
        text-align: left
        margin-top: 10px
        > div
            margin-top: 10px
            font-size: 14px
            font-weight: 500
            &.red
                color: #D50000

</style>

<template lang="pug">
main-right(title="在线充值")
    .pay-sus
        .ok-top
            img(src="../assets/pay-ok.png" v-if="isSuccess")
            img(src="../assets/pay-nok.png" v-else)

            div(v-if="isSuccess") 恭喜您，充值成功！您已成功支付
                span(style="margin-left: 5px;") {{payedInfo.amount}}元
            div(v-else) 对不起，充值失败！充值出现问题，您可以
                span(@click="goUrl('/recharge')") 再试一次
                | 或者
                span(@click="") 联系我们
        .btns
            .btn(@click="goUrl('/recharge')") {{isSuccess ? '继续' : '重新'}}充值
            .btn.cur(@click="goUrl('/home')") 返回首页
        .charge-info(v-if="isSuccess")
            .left-right 订单编号
                span(:title="payedInfo.tradeNo") {{payedInfo.tradeNo}}
            .left-right 付款金额
                span {{payedInfo.amount}}元
            .left-right.br 支付方式
                span {{payedInfo.topupTypeName}}
        .qrs
            .qr(v-for="(item, i) in qrs" :key="i")
                img(:src="item.url")
                .name {{item.name}}
        .tips 温馨提示:
            div 1.如果在充值中有任何问题请致电021-65688628。
            div.red 2.梯之星客服不会擅自为您办理退款，请您提高警惕，谨防诈骗。
</template>

<script>
import qrAndroid from '../assets/qrAndroid.png'
import qrIos from '../assets/qrIos.png'
export default {
    name: 'order-pay-res',
    data(){
        return {
            // qrs: [{url: qr, name: '下载Android APP'},{url: qr, name: '下载IOS APP'},{url: qr, name: '关注公众号，领取优惠券'}],
            qrs: [
                {url: qrAndroid, name: '下载Android APP'},
                {url: qrIos, name: '下载IOS APP'}
                // ,{url: qr, name: '关注公众号，领取优惠券'}
            ],
            payedInfo: { amount: 0, tradeNo: '' },
            isSuccess: this.$route.query.type == 1
        }
    },
    async created() {
        /*
            amount: 10
            topupType: 1001
            topupTypeName: "充值 (支付宝)"
            tradeNo: "2020081319124575424621298867062"
        */
        let { amount } = this.$route.query
        if (amount) {
            amount = amount / 1e3
            this.payedInfo = { ...this.$route.query, amount }
        }
    }
}
</script>


